module.exports = __webpack_public_path__ + "img/pure_oak_946e_list.8596b56a.jpg";